<template>
  <div>
    <v-btn
        color="#616161"
        class="white--text"
        tile
        width="140"
        @click="handleAuthClick"
        v-if="!authorized"
    >
      {{ $t("authorize") }}
    </v-btn>
    <v-btn
        color="#616161"
        class="white--text"
        tile
        width="140"
        :disabled="!pickerInited"
        @click="openPicker"
        v-else
    >
      {{ $t("select a video") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    clientId: { type: String, required: true },
    apiKey: { type: String, required: true },
    appId: { type: String, required: true },
    scopes: { type: String, required: true }
  },

  data () {
    return {
      tokenClient: null,
      accessToken: null,
      authorized: false,
      pickerInited: false,
      gisInited: false
    }
  },

  mounted () {
    this.loadGapi()
    this.loadGis()
  },

  methods: {
    loadGapi () {
      const s = document.createElement('script')
      s.src = 'https://apis.google.com/js/api.js'
      s.onload = this.gapiLoaded
      document.body.appendChild(s)
    },

    loadGis () {
      const s = document.createElement('script')
      s.src = 'https://accounts.google.com/gsi/client'
      s.onload = this.gisLoaded
      document.body.appendChild(s)
    },

    async gapiLoaded () {
      window.gapi.load('client:picker', async () => {
        await window.gapi.client.load(
            'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'
        )
        this.pickerInited = true
      })
    },

    gisLoaded () {
      this.tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: this.clientId,
        scope: this.scopes,
        callback: ''
      })

      this.gisInited = true
    },

    handleAuthClick () {
      if (!this.gisInited) return

      this.tokenClient.callback = (resp) => {
        if (resp.error) return

        this.accessToken = resp.access_token
        this.authorized = true

        this.openPicker()
      }

      this.tokenClient.requestAccessToken({
        prompt: this.accessToken ? '' : 'consent'
      })
    },

    openPicker () {
      if (!this.pickerInited || !this.accessToken) return

      const view = new window.google.picker.View(
          window.google.picker.ViewId.DOCS
      )

      view.setMimeTypes('video/mp4')

      const picker = new window.google.picker.PickerBuilder()
          .setDeveloperKey(this.apiKey)
          .setAppId(this.appId)
          .setOAuthToken(this.accessToken)
          .addView(view)
          .setCallback(this.pickerCallback)
          .build()

      picker.setVisible(true)
    },

    async pickerCallback (data) {
      if (data.action !== window.google.picker.Action.PICKED) return

      const fileId = data.docs[0].id

      const res = await window.gapi.client.drive.files.get({
        fileId,
        fields: '*'
      })

      this.$emit('picked', {
        fileId: res.result.id,
        name: res.result.name,
        mimeType: res.result.mimeType,
        size: res.result.size
      }, this.accessToken)
    }
  }
}
</script>
